import { ready } from './utils';

// Open the "Read this in the app" modal, unless a cookie shows the user has closed it recently
const openModalSlide = () => {
  try {
    const closedAppModal = Cookies.get('closedAppModal');
    if (closedAppModal && closedAppModal !== '') {
      // Any truthy value
      return;
    }

    const modal = document.getElementById('slideup-modal-overlay');
    const wrapper = document.getElementById('ti-wrapper');

    modal.classList.remove('not-visible');

    if (!modal.dataset.disableOverlay) {
      // Add an event listener to the body when the slider is open
      // So that the user can click that as well as the close button
      modal.addEventListener('transitionend', function _listener() {
        modal.removeEventListener('transitionend', _listener);
        wrapper.addEventListener('click', closeModalSlide);
      });

      // First add the overlay to the body wrapper (creating an :after pseudo element)
      // Then add the class which darkens the pseudo element, creating the fadein effect
      // We need the `void wrapper.offsetHeight` to prevent the rendering engine from optimizing these two steps into one
      wrapper.classList.add('menu-overlay-open');
      void wrapper.offsetHeight;
      wrapper.classList.add('slide-up-darkened');
    }
  } catch (e) {
    Rollbar.error('There is an error while adding the App Modal Slider', e);
  }
};

// Close the modal and use cookie to remember not to show again for a while
const closeModalSlide = (e) => {
  try {
    e.preventDefault();

    const modal = document.getElementById('slideup-modal-overlay');
    const wrapper = document.getElementById('ti-wrapper');

    const DEFER_DAY = 1;
    const DEFER_WEEK = 7.3; // Don't show again for 7.3 days - not "same time next week"

    Cookies.set('closedAppModal', 'true', {
      expires: modal.dataset.shortDeferral ? DEFER_DAY : DEFER_WEEK,
    });

    wrapper.removeEventListener('click', closeModalSlide);
    // Remove the pseudo-element body-wrapper overlay only after it has become transparent
    modal.addEventListener('transitionend', function _listener() {
      wrapper.removeEventListener('transitionend', _listener);
      wrapper.classList.remove('menu-overlay-open');
    });
    modal.classList.add('not-visible');
    wrapper.classList.remove('slide-up-darkened');
  } catch (e) {
    Rollbar.error('There is an error while adding the App Modal Slider', e);
  }
};

// Set up some initial event listeners
ready(() => {
  const overlay = document.getElementById('slideup-modal-overlay');
  const closeBtn = document.getElementById('slideup-modal-close');

  // The overlay originally has a "display: none" attached to prevent loading jank
  if (overlay) {
    overlay.classList.remove('initial-not-visible');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModalSlide);
  }
});

export default openModalSlide;
